import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.28,0 1920,430.613333 1920,960 C1920,1489.38667 1489.28,1920 960,1920 C430.72,1920 0,1489.38667 0,960 C0,720.96 88.64,494.08 244.48,320 L244.48,320 L53.3333333,320 L53.3333333,106.666667 L640,106.666667 L640,693.333333 L426.666667,693.333333 L426.666667,439.253333 C291.733333,577.386667 213.333333,762.986667 213.333333,960 C213.333333,1371.62667 548.266667,1706.66667 960,1706.66667 C1371.73333,1706.66667 1706.66667,1371.62667 1706.66667,960 C1706.66667,548.373333 1371.73333,213.333333 960,213.333333 L960,213.333333 Z M1151.25333,671.253333 L1302.08,822.08 L1110.82667,1013.33333 L1302.08,1204.58667 L1151.25333,1355.41333 L960,1164.16 L768.746667,1355.41333 L617.92,1204.58667 L809.173333,1013.33333 L617.92,822.08 L768.746667,671.253333 L960,862.506667 L1151.25333,671.253333 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSisNotSyncedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSisNotSyncedSolid, _Component);

  var _super = _createSuper(IconSisNotSyncedSolid);

  function IconSisNotSyncedSolid() {
    _classCallCheck(this, IconSisNotSyncedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSisNotSyncedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSisNotSynced",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSisNotSyncedSolid.displayName = "IconSisNotSyncedSolid";
  return IconSisNotSyncedSolid;
}(Component);

IconSisNotSyncedSolid.glyphName = 'sis-not-synced';
IconSisNotSyncedSolid.variant = 'Solid';
IconSisNotSyncedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSisNotSyncedSolid;
export { IconSisNotSyncedSolid };